module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kb-block-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.to
    }
  }, [(_vm.title || _vm.details) ? _c('div', {
    staticClass: "info-wrapper"
  }, [(_vm.title) ? _c('h3', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.details) ? _c('p', [_vm._v(_vm._s(_vm.details))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7748cff6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/KbBlockLink.vue
// module id = 2057
// module chunks = 2